'use client'

import { useRef } from 'react'
import Image from 'next/image'
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion'


const PhoneContactScreen = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const scrollRef = useRef<HTMLDivElement>(null)
  const slideRef = useRef<(HTMLDivElement | null)>(null)

  const mouseX = useMotionValue(0)
  const mouseY = useMotionValue(0)

  const springConfig = { stiffness: 150, damping: 20, mass: 0.5 }
  const rotateX = useSpring(useTransform(mouseY, [-0.5, 0.5], [12, -12]), springConfig)
  const rotateY = useSpring(useTransform(mouseX, [-0.5, 0.5], [-10, 10]), springConfig)
  const translateX = useSpring(useTransform(mouseX, [-0.5, 0.5], [-16, 16]), springConfig)
  const translateY = useSpring(useTransform(mouseY, [-0.5, 0.5], [-16, 16]), springConfig)

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = containerRef.current?.getBoundingClientRect()
    if (!rect) return
    mouseX.set((e.clientX - rect.left) / rect.width - 0.5)
    mouseY.set((e.clientY - rect.top) / rect.height - 0.5)
  }

  const handleMouseLeave = () => {
    mouseX.set(0)
    mouseY.set(0)
  }

  
  return (
        <div
          ref={containerRef}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          className="absolute inset-x-0 bottom-0 w-full object-contain object-bottom">
          <motion.div
            style={{
              rotateX,
              rotateY,
              x: translateX,
              y: translateY,
              transformStyle: 'preserve-3d',
            }}>
            <div
              ref={scrollRef}
              className="no-scrollbar flex w-full snap-x snap-mandatory overflow-x-auto">
                <div
                  ref={(el) => {
                    slideRef.current = el
                  }}
                  className="flex w-full flex-shrink-0 snap-center justify-center">
                  <Image
                    src={'/images/homepage/how_works_phone_sc.webp'}
                    alt={`Phone Contacts`}
                    width={400}
                    height={618}
                    className="w-[240px] sm:w-[400px] h-auto drop-shadow-[0_40px_70px_rgba(37,99,235,0.35)] select-none pointer-events-none"
                    draggable={false}
                  />
                </div>
            </div>
          </motion.div>
        </div>
  )
}

export default PhoneContactScreen
